'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SearchForItems = function SearchForItems(props) {
  return React__default["default"].createElement("svg", _objectSpread({
    width: "816",
    height: "426",
    viewBox: "0 0 816 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default["default"].createElement("rect", {
    y: "259",
    width: "816",
    height: "167",
    fill: "url(#paint0_radial)"
  }), React__default["default"].createElement("rect", {
    opacity: "0.4",
    x: "108",
    y: "259",
    width: "600",
    height: "2",
    rx: "1",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "348",
    y: "79",
    width: "120",
    height: "180",
    rx: "2",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M347.684 80.617C347.868 79.6778 348.691 79 349.647 79H465.872C466.82 79 467.638 79.6657 467.83 80.594L475.751 118.797C475.879 119.418 475.405 120 474.771 120H341.214C340.585 120 340.112 119.426 340.232 118.808L347.684 80.617Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M157.055 128.553C157.264 127.644 158.072 127 159.005 127H296.429C297.351 127 298.154 127.63 298.372 128.526L307.698 166.763C307.852 167.393 307.375 168 306.727 168H149.256C148.613 168 148.137 167.403 148.281 166.776L157.055 128.553Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M517.972 144.51C518.196 143.622 518.995 143 519.911 143H671.466C672.371 143 673.163 143.608 673.398 144.482L683.662 182.741C683.833 183.376 683.354 184 682.696 184H509.284C508.632 184 508.155 183.387 508.314 182.755L517.972 144.51Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter0_f)"
  }, React__default["default"].createElement("path", {
    d: "M469.817 259H345.694C344.717 259 343.882 259.707 343.721 260.671L332.388 328.671C332.185 329.89 333.125 331 334.361 331H428H481.623C482.864 331 483.806 329.881 483.593 328.658L471.788 260.658C471.621 259.7 470.79 259 469.817 259Z",
    fill: "#00314A"
  })), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter1_f)"
  }, React__default["default"].createElement("path", {
    d: "M299.978 259H155.459C154.54 259 153.739 259.626 153.518 260.518L140.616 312.518C140.303 313.78 141.257 315 142.557 315H251.158H313.417C314.725 315 315.681 313.766 315.354 312.5L301.914 260.5C301.686 259.617 300.889 259 299.978 259Z",
    fill: "#00314A"
  })), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter2_f)"
  }, React__default["default"].createElement("path", {
    d: "M674.85 259H516.539C515.708 259 514.963 259.514 514.669 260.291L501.026 296.291C500.531 297.6 501.497 299 502.897 299H621.263H689.06C690.471 299 691.439 297.578 690.921 296.266L676.71 260.266C676.409 259.502 675.671 259 674.85 259Z",
    fill: "#00314A"
  })), React__default["default"].createElement("path", {
    d: "M340 120C340 119.448 340.448 119 341 119H475C475.552 119 476 119.448 476 120V321C476 322.105 475.105 323 474 323H342C340.895 323 340 322.105 340 321V120Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M148 168C148 167.448 148.448 167 149 167H307C307.552 167 308 167.448 308 168V305C308 306.105 307.105 307 306 307H150C148.895 307 148 306.105 148 305V168Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M508 184C508 183.448 508.448 183 509 183H683C683.552 183 684 183.448 684 184V289C684 290.105 683.105 291 682 291H510C508.895 291 508 290.105 508 289V184Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("mask", {
    id: "path-13-inside-1",
    fill: "white"
  }, React__default["default"].createElement("path", {
    d: "M393.797 79.9105C393.845 78.8418 394.725 78 395.795 78H420.093C421.161 78 422.04 78.8385 422.091 79.9049L423.95 118.952C423.977 119.523 423.522 120 422.951 120H393.046C392.476 120 392.021 119.525 392.047 118.955L393.797 79.9105Z"
  })), React__default["default"].createElement("path", {
    d: "M393.797 79.9105C393.845 78.8418 394.725 78 395.795 78H420.093C421.161 78 422.04 78.8385 422.091 79.9049L423.95 118.952C423.977 119.523 423.522 120 422.951 120H393.046C392.476 120 392.021 119.525 392.047 118.955L393.797 79.9105Z",
    fill: "#3387CD",
    stroke: "#0069C0",
    strokeWidth: "4",
    mask: "url(#path-13-inside-1)"
  }), React__default["default"].createElement("path", {
    d: "M423 119H393V164L396.75 160L400.5 164L404 160L408 164L411.75 160L415.5 164L419.25 160L423 164V119Z",
    fill: "#0069C0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("rect", {
    x: "397.208",
    y: "108.011",
    width: "24",
    height: "4",
    rx: "2",
    transform: "rotate(-88 397.208 108.011)",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "407",
    y: "119",
    width: "40",
    height: "2",
    rx: "1",
    transform: "rotate(-90 407 119)",
    fill: "#0069C0"
  }), React__default["default"].createElement("mask", {
    id: "path-17-inside-2",
    fill: "white"
  }, React__default["default"].createElement("path", {
    d: "M213.797 127.91C213.845 126.842 214.725 126 215.795 126H240.093C241.161 126 242.04 126.838 242.091 127.905L243.95 166.952C243.977 167.523 243.522 168 242.951 168H213.046C212.476 168 212.021 167.525 212.047 166.955L213.797 127.91Z"
  })), React__default["default"].createElement("path", {
    d: "M213.797 127.91C213.845 126.842 214.725 126 215.795 126H240.093C241.161 126 242.04 126.838 242.091 127.905L243.95 166.952C243.977 167.523 243.522 168 242.951 168H213.046C212.476 168 212.021 167.525 212.047 166.955L213.797 127.91Z",
    fill: "#3387CD",
    stroke: "#0069C0",
    strokeWidth: "4",
    mask: "url(#path-17-inside-2)"
  }), React__default["default"].createElement("path", {
    d: "M243 167H213V212L216.75 208L220.5 212L224 208L228 212L231.75 208L235.5 212L239.25 208L243 212V167Z",
    fill: "#0069C0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("rect", {
    x: "217.208",
    y: "156.011",
    width: "24",
    height: "4",
    rx: "2",
    transform: "rotate(-88 217.208 156.011)",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "227",
    y: "167",
    width: "40",
    height: "2",
    rx: "1",
    transform: "rotate(-90 227 167)",
    fill: "#0069C0"
  }), React__default["default"].createElement("mask", {
    id: "path-21-inside-3",
    fill: "white"
  }, React__default["default"].createElement("path", {
    d: "M581.797 143.91C581.845 142.842 582.725 142 583.795 142H608.093C609.161 142 610.04 142.838 610.091 143.905L611.95 182.952C611.977 183.523 611.522 184 610.951 184H581.046C580.476 184 580.021 183.525 580.047 182.955L581.797 143.91Z"
  })), React__default["default"].createElement("path", {
    d: "M581.797 143.91C581.845 142.842 582.725 142 583.795 142H608.093C609.161 142 610.04 142.838 610.091 143.905L611.95 182.952C611.977 183.523 611.522 184 610.951 184H581.046C580.476 184 580.021 183.525 580.047 182.955L581.797 143.91Z",
    fill: "#3387CD",
    stroke: "#0069C0",
    strokeWidth: "4",
    mask: "url(#path-21-inside-3)"
  }), React__default["default"].createElement("path", {
    d: "M611 183H581V228L584.75 224L588.5 228L592 224L596 228L599.75 224L603.5 228L607.25 224L611 228V183Z",
    fill: "#0069C0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("rect", {
    x: "585.208",
    y: "172.011",
    width: "24",
    height: "4",
    rx: "2",
    transform: "rotate(-88 585.208 172.011)",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "595",
    y: "183",
    width: "40",
    height: "2",
    rx: "1",
    transform: "rotate(-90 595 183)",
    fill: "#0069C0"
  }), React__default["default"].createElement("g", {
    filter: "url(#filter3_ddd)"
  }, React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.525 173.13C298.468 173.13 300.87 175.532 300.87 178.475V191.679C300.87 193.148 300.278 194.487 299.296 195.469L282.32 212.446C281.352 213.413 280.012 214 278.549 214C277.087 214 275.742 213.414 274.77 212.42L261.58 199.23C260.586 198.258 260 196.913 260 195.451C260 193.977 260.614 192.621 261.573 191.661L278.55 174.685C279.517 173.717 280.858 173.13 282.321 173.13H295.525ZM288.739 179.704C290.276 178.167 292.76 178.167 294.297 179.704C295.834 181.241 295.834 183.724 294.297 185.261C292.76 186.798 290.276 186.798 288.739 185.261C287.202 183.724 287.202 181.241 288.739 179.704Z",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("path", {
    d: "M267.62 196.376C267.313 196.069 267.313 195.572 267.62 195.265C267.927 194.958 268.424 194.958 268.731 195.265L278.735 205.268C279.042 205.575 279.042 206.073 278.735 206.38C278.428 206.687 277.93 206.687 277.624 206.38L267.62 196.376Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M273.177 190.818C272.87 190.511 272.87 190.014 273.177 189.707C273.484 189.4 273.982 189.4 274.289 189.707L284.292 199.71C284.599 200.017 284.599 200.515 284.292 200.822C283.985 201.129 283.487 201.129 283.18 200.822L273.177 190.818Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M279.845 184.149C279.538 183.842 279.538 183.345 279.845 183.038C280.152 182.731 280.65 182.731 280.956 183.038L290.96 193.041C291.267 193.348 291.267 193.846 290.96 194.153C290.653 194.46 290.155 194.46 289.848 194.153L279.845 184.149Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M270.398 194.709C269.785 194.095 269.785 193.1 270.398 192.486C271.012 191.872 272.008 191.872 272.621 192.486L281.513 201.378C282.127 201.992 282.127 202.987 281.513 203.601C280.9 204.215 279.904 204.215 279.29 203.601L270.398 194.709Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M275.956 189.151C275.342 188.537 275.342 187.542 275.956 186.928L277.067 185.817C277.681 185.203 278.676 185.203 279.29 185.817L288.182 194.709C288.796 195.323 288.796 196.318 288.182 196.932L287.071 198.043C286.457 198.657 285.461 198.657 284.848 198.043L275.956 189.151Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.059 166.46C287.673 165.847 288.668 165.847 289.282 166.46C291.846 169.025 293.378 172.181 293.963 175.13C294.536 178.013 294.249 180.983 292.762 182.965C292.241 183.659 291.256 183.8 290.562 183.279C289.867 182.758 289.726 181.773 290.247 181.078C290.984 180.096 291.363 178.175 290.88 175.742C290.41 173.374 289.162 170.787 287.059 168.683C286.445 168.07 286.445 167.074 287.059 166.46Z",
    fill: "#0069C0"
  })), React__default["default"].createElement("g", {
    filter: "url(#filter4_ddd)"
  }, React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.525 125.13C465.468 125.13 467.87 127.532 467.87 130.475V143.679C467.87 145.148 467.278 146.487 466.296 147.469L449.32 164.446C448.352 165.413 447.012 166 445.549 166C444.087 166 442.742 165.414 441.77 164.42L428.58 151.23C427.586 150.258 427 148.913 427 147.451C427 145.977 427.614 144.621 428.573 143.661L445.55 126.685C446.517 125.717 447.858 125.13 449.321 125.13H462.525ZM455.739 131.704C457.276 130.167 459.76 130.167 461.297 131.704C462.834 133.241 462.834 135.724 461.297 137.261C459.76 138.798 457.276 138.798 455.739 137.261C454.202 135.724 454.202 133.241 455.739 131.704Z",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("path", {
    d: "M434.62 148.376C434.313 148.069 434.313 147.572 434.62 147.265C434.927 146.958 435.424 146.958 435.731 147.265L445.735 157.268C446.042 157.575 446.042 158.073 445.735 158.38C445.428 158.687 444.93 158.687 444.624 158.38L434.62 148.376Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M440.177 142.818C439.87 142.511 439.87 142.014 440.177 141.707C440.484 141.4 440.982 141.4 441.289 141.707L451.292 151.71C451.599 152.017 451.599 152.515 451.292 152.822C450.985 153.129 450.487 153.129 450.18 152.822L440.177 142.818Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M446.845 136.149C446.538 135.842 446.538 135.345 446.845 135.038C447.152 134.731 447.65 134.731 447.956 135.038L457.96 145.041C458.267 145.348 458.267 145.846 457.96 146.153C457.653 146.46 457.155 146.46 456.848 146.153L446.845 136.149Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M437.398 146.709C436.785 146.095 436.785 145.1 437.398 144.486C438.012 143.872 439.008 143.872 439.621 144.486L448.513 153.378C449.127 153.992 449.127 154.987 448.513 155.601C447.9 156.215 446.904 156.215 446.29 155.601L437.398 146.709Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M442.956 141.151C442.342 140.537 442.342 139.542 442.956 138.928L444.067 137.817C444.681 137.203 445.676 137.203 446.29 137.817L455.182 146.709C455.796 147.323 455.796 148.318 455.182 148.932L454.071 150.043C453.457 150.657 452.461 150.657 451.848 150.043L442.956 141.151Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.059 118.46C454.673 117.847 455.668 117.847 456.282 118.46C458.846 121.025 460.378 124.181 460.963 127.13C461.536 130.013 461.249 132.983 459.762 134.965C459.241 135.659 458.256 135.8 457.562 135.279C456.867 134.758 456.726 133.773 457.247 133.078C457.984 132.096 458.363 130.175 457.88 127.742C457.41 125.374 456.162 122.787 454.059 120.683C453.445 120.07 453.445 119.074 454.059 118.46Z",
    fill: "#0069C0"
  })), React__default["default"].createElement("g", {
    filter: "url(#filter5_ddd)"
  }, React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M671.525 189.13C674.468 189.13 676.87 191.532 676.87 194.475V207.679C676.87 209.148 676.278 210.487 675.296 211.469L658.32 228.446C657.352 229.413 656.012 230 654.549 230C653.087 230 651.742 229.414 650.77 228.42L637.58 215.23C636.586 214.258 636 212.913 636 211.451C636 209.977 636.614 208.621 637.573 207.661L654.55 190.685C655.517 189.717 656.858 189.13 658.321 189.13H671.525ZM664.739 195.704C666.276 194.167 668.76 194.167 670.297 195.704C671.834 197.241 671.834 199.724 670.297 201.261C668.76 202.798 666.276 202.798 664.739 201.261C663.202 199.724 663.202 197.241 664.739 195.704Z",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("path", {
    d: "M643.62 212.376C643.313 212.069 643.313 211.572 643.62 211.265C643.927 210.958 644.424 210.958 644.731 211.265L654.735 221.268C655.042 221.575 655.042 222.073 654.735 222.38C654.428 222.687 653.93 222.687 653.624 222.38L643.62 212.376Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M649.177 206.818C648.87 206.511 648.87 206.014 649.177 205.707C649.484 205.4 649.982 205.4 650.289 205.707L660.292 215.71C660.599 216.017 660.599 216.515 660.292 216.822C659.985 217.129 659.487 217.129 659.18 216.822L649.177 206.818Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M655.845 200.149C655.538 199.842 655.538 199.345 655.845 199.038C656.152 198.731 656.65 198.731 656.956 199.038L666.96 209.041C667.267 209.348 667.267 209.846 666.96 210.153C666.653 210.46 666.155 210.46 665.848 210.153L655.845 200.149Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M646.398 210.709C645.785 210.095 645.785 209.1 646.398 208.486C647.012 207.872 648.008 207.872 648.621 208.486L657.513 217.378C658.127 217.992 658.127 218.987 657.513 219.601C656.9 220.215 655.904 220.215 655.29 219.601L646.398 210.709Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M651.956 205.151C651.342 204.537 651.342 203.542 651.956 202.928L653.067 201.817C653.681 201.203 654.676 201.203 655.29 201.817L664.182 210.709C664.796 211.323 664.796 212.318 664.182 212.932L663.071 214.043C662.457 214.657 661.461 214.657 660.848 214.043L651.956 205.151Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M663.059 182.46C663.673 181.847 664.668 181.847 665.282 182.46C667.846 185.025 669.378 188.181 669.963 191.13C670.536 194.013 670.249 196.983 668.762 198.965C668.241 199.659 667.256 199.8 666.562 199.279C665.867 198.758 665.726 197.773 666.247 197.078C666.984 196.096 667.363 194.175 666.88 191.742C666.41 189.374 665.162 186.787 663.059 184.683C662.445 184.07 662.445 183.074 663.059 182.46Z",
    fill: "#0069C0"
  })), React__default["default"].createElement("rect", {
    x: "483.149",
    y: "164.049",
    width: "14",
    height: "78",
    transform: "rotate(-45 483.149 164.049)",
    fill: "#93C0E4",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("circle", {
    cx: "442.137",
    cy: "113.137",
    r: "72",
    transform: "rotate(-45 442.137 113.137)",
    stroke: "#3387CD",
    strokeWidth: "16"
  }), React__default["default"].createElement("path", {
    d: "M388.154 168.292C357.693 137.831 357.693 88.4438 388.154 57.9829",
    stroke: "#C2DBF0",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("circle", {
    cx: "442.137",
    cy: "113.137",
    r: "63",
    transform: "rotate(-45 442.137 113.137)",
    fill: "#2196F3",
    fillOpacity: "0.1",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M402.539 152.735C380.67 130.866 380.67 95.4086 402.539 73.5392",
    stroke: "white",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M583.559 254.559C578.872 259.245 571.274 259.245 566.588 254.559L508.605 196.576C507.824 195.795 507.824 194.529 508.605 193.747L522.747 179.605C523.528 178.824 524.795 178.824 525.576 179.605L583.559 237.588C588.245 242.274 588.245 249.872 583.559 254.559Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M583.559 254.559C578.872 259.245 571.274 259.245 566.588 254.559L508.605 196.576C507.824 195.795 507.824 194.529 508.605 193.747L522.747 179.605C523.528 178.824 524.795 178.824 525.576 179.605L583.559 237.588C588.245 242.274 588.245 249.872 583.559 254.559Z",
    stroke: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "511.434",
    y: "188.091",
    width: "16",
    height: "4",
    rx: "2",
    transform: "rotate(-135 511.434 188.091)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "491.371",
    y: "131.259",
    width: "32",
    height: "2",
    rx: "1",
    transform: "rotate(-90 491.371 131.259)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "482.623",
    y: "147.966",
    width: "64",
    height: "2",
    rx: "1",
    transform: "rotate(-90 482.623 147.966)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "578.609",
    y: "242.538",
    width: "40",
    height: "4",
    rx: "2",
    transform: "rotate(-135 578.609 242.538)",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("filter", {
    id: "filter0_f",
    x: "320.36",
    y: "247",
    width: "175.263",
    height: "96",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    id: "filter1_f",
    x: "128.556",
    y: "247",
    width: "198.862",
    height: "80",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    id: "filter2_f",
    x: "488.895",
    y: "247",
    width: "214.167",
    height: "64",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    id: "filter3_ddd",
    x: "255",
    y: "162",
    width: "50.8696",
    height: "58",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feOffset", {
    dy: "1"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "2.5"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feOffset", {
    dy: "2"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "1"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feMorphology", {
    radius: "2",
    operator: "erode",
    "in": "SourceAlpha",
    result: "effect3_dropShadow"
  }), React__default["default"].createElement("feOffset", {
    dy: "3"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "0.5"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })), React__default["default"].createElement("filter", {
    id: "filter4_ddd",
    x: "422",
    y: "114",
    width: "50.8696",
    height: "58",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feOffset", {
    dy: "1"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "2.5"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feOffset", {
    dy: "2"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "1"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feMorphology", {
    radius: "2",
    operator: "erode",
    "in": "SourceAlpha",
    result: "effect3_dropShadow"
  }), React__default["default"].createElement("feOffset", {
    dy: "3"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "0.5"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })), React__default["default"].createElement("filter", {
    id: "filter5_ddd",
    x: "631",
    y: "178",
    width: "50.8696",
    height: "58",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feOffset", {
    dy: "1"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "2.5"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feOffset", {
    dy: "2"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "1"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feMorphology", {
    radius: "2",
    operator: "erode",
    "in": "SourceAlpha",
    result: "effect3_dropShadow"
  }), React__default["default"].createElement("feOffset", {
    dy: "3"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "0.5"
  }), React__default["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })), React__default["default"].createElement("radialGradient", {
    id: "paint0_radial",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(408 259) rotate(90) scale(146 509.128)"
  }, React__default["default"].createElement("stop", {
    stopColor: "#2196F3",
    stopOpacity: "0.08"
  }), React__default["default"].createElement("stop", {
    offset: "1",
    stopColor: "#C4C4C4",
    stopOpacity: "0"
  }))));
};

module.exports = SearchForItems;
